import type { Directive } from "vue";
import { nextTick } from "vue";

export default {
  mounted(el: HTMLElement, binding: any) {
    if (binding.value === false) return;

    const input = el.tagName === "INPUT" ? el : (findFirstFocusableEl(el) as HTMLElement);

    nextTick(() => {
      setTimeout(() => {
        input?.focus();
      }, 50);
    });
  },
} as Directive;

function findFirstFocusableEl(el: HTMLElement) {
  let focusableEls = el.querySelectorAll("input, select");

  if (focusableEls.length === 0) {
    focusableEls = el.querySelectorAll(
      'input[type="text"]:not([disabled]):not([tabindex="-1"]), input[type="radio"]:not([disabled]):not([tabindex="-1"]), input[type="checkbox"]:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"])'
    );
  }

  if (focusableEls.length === 0) {
    focusableEls = el.querySelectorAll(
      'button:not([disabled]):not([tabindex="-1"]), button[role="combobox"]:not([disabled]):not([tabindex="-1"]), a[href]:not([tabindex="-1"])'
    );
  }

  return focusableEls.length > 0 ? focusableEls[0] : null;
}
